import { createAsyncThunk } from '@reduxjs/toolkit';
import getEmployerFilingsAccess from 'scenes/EmployerFilings/store/services/getEmployerFilingsAccess.service';

// Whether the user has filings_manage in at least one of the employer's
// projects - decides if the dashboard shows the overview button.
export const loadEmployerFilingsAccess = createAsyncThunk(
  'employerFilings/loadEmployerFilingsAccess',
  async (employerProjectId) => {
    const response = await getEmployerFilingsAccess(employerProjectId);

    return {
      employerProjectId,
      hasAccess: response?.hasAccess === true,
    };
  }
);
